import React from "react";
// import { Link } from "react-router-dom";




export default class FoodTrucks extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb5.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>food trucks</h2>
                            <a href="index.html">Home</a> - <a href="news.html">Food Trucks</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">

                        <section class="our-client-container">
                            <div class="container"> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Village Cafe Food Trucks - Healthy South Indian Food On-the-Go</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>Our <span style={{fontWeight:'700'}}>Village Cafe Food Trucks </span>bring <span style={{fontWeight:'700'}}>traditional South Indian food </span>closer to you. With <span style={{fontWeight:'700'}}>multiple food trucks across Hyderabad</span>, we make sure you can enjoy <span style={{fontWeight:'700'}}>healthy, homely meals </span>wherever you are.</p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                                <div class="our-client text-left">
                                    <h3 style={{marginLeft:20}}>Find us near : </h3>
                                </div>
                                    
                            </div>
                        </section>



                    <section class="event-container" style={{marginTop:50}}>
                        <div class="container">
                        <div class="news-detail">
                            <div class="row">
                            <div class="col-md-12 col-sm-12 col-xs-12">
                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Corporate Parks</h3>
                                            <p>Perfect for office lunches</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}

                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Residential Communities</h3>
                                            <p>Ideal for families</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}

                                <div class="event-detail-wrap">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="event-pic" style={{alignItems:'center',justifyContent:'center'}}>
                                            <img src="/assets/images/news1.jpg" alt="" />
                                        </div>
                                        <div style={{marginTop:40,marginBottom:100}}>
                                            <h3 style={{paddingTop:40}}>Event Locations</h3>
                                            <p>Festivals, gatherings, parties</p>
                                        </div>
                                    </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                     
                                {/* <div> 
                                    <span style={{fontSize:20,fontWeight:'700'}}>Each food truck serves our signature dishes -</span>
                                    <p><span style={{fontWeight:'700'}}>ragi dosa </span>and <span style={{fontWeight:'700'}}>jowar roti </span>to <span style={{fontWeight:'700'}}>village-style thalis</span>.</p>
                                </div> */}

                                {/* <div class="event-detail-wrap event-detail-noimg">
                                    <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms"> 
                                        <p>Each food truck serves our signature dishes - from <span style={{fontWeight:'700'}}>ragi dosa </span>and <span style={{fontWeight:'700'}}>jowar roti </span>to <span style={{fontWeight:'700'}}>village-style thalis</span>.</p>
                                    </div> {/* <!-- event-list --> */}
                                {/* </div> <!-- event-wrap --> */} 
                                
                                {/* <div class="news-pagination">
                                <ul>
                                    <li class="active"><a href="#/">1</a></li>
                                    <li><a href="#/">2</a></li>
                                    <li><a href="#/">3</a></li>
                                    <li><a href="#/"><i class="fa fa-chevron-right" aria-hidden="true"></i></a></li>
                                </ul>
                                </div> <!-- news-pagination --> */}
                            </div>
                             
                          
                            </div>
                            </div> {/* <!-- post-detail --> */}
                            <div style={{margin:5}}> 
                                <span style={{fontSize:20}}>Each food truck serves our signature dishes - from <span style={{fontWeight:'700'}}>ragi dosa </span>and <span style={{fontWeight:'700'}}>jowar roti </span>to <span style={{fontWeight:'700'}}>village-style thalis</span>.</span>
                            </div>
                        </div>
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                   
                </div>
            </div>
        )
    }
}